import { genericApiCall, getApiCall } from "../utils/servicesBaseUtil";
import { catchErrors } from "../utils/catchErrors";
import { message } from "antd";

export const getProductListApi = ({ id, finalCallback, successCallback }) => {
  let url = `product-review?survey_id=${id}`;
  getApiCall({ url: url })
    .then((responseJson) => {
      if (responseJson?.success) {
        successCallback(responseJson);
      }
    })
    .catch((error) => {
      catchErrors(error, url);
    })
    .finally(() => {
      finalCallback();
    });
};

export const submitProductReviewApi = ({
  data,
  finalCallback,
  successCallback,
}) => {
  let url = `product-review`;
  let formData = new FormData();
  formData.append("like_description", data?.like_description ?? "");
  formData.append("dislike_description", data?.dislike_description ?? "");
  formData.append("product_id", data?.product_id);
  formData.append("recommend", data?.recommend?.toString());
  formData.append("stars", data?.stars?.toString());
  formData.append("survey_id", data?.survey_id);
  genericApiCall({ url: url, method: "POST", data: formData })
    .then((responseJson) => {
      if (responseJson.success) {
        message.success(responseJson?.message);
        successCallback(responseJson);
      } else {
        message.error();
      }
    })
    .catch((error) => {
      catchErrors(error, url);
    })
    .finally(() => {
      finalCallback();
    });
};
